<div class="avatar" [style.background-image]="'url(' + this.image + ')'">
  @if (this.image == undefined) {
    <h3 class="initial-text">{{this.initials}}</h3>
  }
</div>